<script lang="ts" setup>
import { useLanguage } from '@nzyme/vue-i18n/useLanguage.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';

import type { ScalarMeasurementValue } from '@sigma/common/measurements/ScalarMeasurement.js';
import { UnitTokenTranslation } from '@sigma/common/measurements/UnitTokenTranslation.js';
import type { UnitToken } from '@sigma/common/measurements/UnitTokenTranslation.js';
import { formatNumber } from '@sigma/utils/format/formatNumber.js';

interface Props {
  /**
   * The scalar measurement answer (e.g. height, weight) to display. Typed with the full
   * `UnitToken` domain so `t(UnitTokenTranslation, unit)` type-checks — distributive
   * `Translation<T>` rejects narrow unit unions.
   */
  value: ScalarMeasurementValue<UnitToken>;
}

defineProps<Props>();

const t = useTranslate();
const lang = useLanguage();
</script>

<template>{{ formatNumber(value.value, lang) }} {{ t(UnitTokenTranslation, value.unit) }}</template>
